import React, { useMemo } from 'react';
import DependencyTrackMappingForm from './DependencyTrackMappingForm';
import DependencyTrackCredentialsForm from './DependencyTrackCredentialsForm';
import GenericPullConfigListing from '../GenericPullConfigListing';
import ContentOverlay from 'components/ContentOverlay';
import _ from 'lodash';
import { CellRenderers } from 'utils/tableUtils';

export default function DependencyTrackConfigListing(props) {
    const columns = useMemo(
        () => [
            {
                title: 'Project Name',
                dataIndex: 'projectName',
                width: 240,
                render: (project, record) => {
                    if (_.isEmpty(project)) {
                        return CellRenderers.VALUE_OR_NA(project);
                    }

                    const renderName = project
                        .split(',')
                        .map((item) => <p>{item.replace(/;/g, '-')}</p>);
                    return (
                        <ContentOverlay content={renderName} minHeight={40} />
                    );
                },
            },
        ],
        []
    );
    return (
        <GenericPullConfigListing
            {...props}
            toolName={props.name}
            MappingForm={DependencyTrackMappingForm}
            CredentialsForm={DependencyTrackCredentialsForm}
            extraColumns={columns}
        />
    );
}
